import React from 'react';
import ReactDOM from 'react-dom';
import DSRForm from './components/DSRForm';
import { IntlProvider } from 'react-intl';
import normalizeWidgetInput from 'src/common/normalizeWidgetInput';
import { RenderFn } from 'src/types/widgets';
import widgetDefinition from './PrivacyDSRForm.widget';
import 'carbon-components/css/carbon-components.min.css';
const render: RenderFn = async function (instanceId, langCode, origin, cb) {
  const { element, locale, messages } = await normalizeWidgetInput(
    instanceId,
    langCode,
    widgetDefinition,
  );

  if (!element || !locale) {
    return;
  }
  ReactDOM.render(
    <React.StrictMode>
      <IntlProvider locale={locale} messages={messages}>
        <DSRForm />
      </IntlProvider>
    </React.StrictMode>,
    element,
    () => cb(element),
  );
};
export default render;
